export const PRICELINE_MAP_ID = '9b78a88e3a09bc92';
export const GOOGLE_MAP_API_KEY = 'AIzaSyA3oQ_k-qetNGi1rYpeR2zlIoWQqczXnls';